import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetName = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback((name: string) => dispatch({ type: 'SET_CAMPAIGN_NAME', payload: { name } }), [dispatch]);
};
